<template>
  <div class="center">
    <div class="square_titulo_vacio">
      <div class="square_titulo_valores_vacio" ID="Div9" runat="server"></div>
    </div>
    <div class="q-pa-md row items-start">
      <q-card class="my-card-resetear">
        <q-card-section class="card_titulo">
          <div class="card_titulo_text">Cambiar Contraseña</div>
        </q-card-section>
        <q-card-actions align="left">
          <div class="flex-container">
            <div class="flex-item_5"></div>
            <div class="flex-item_70">
              <q-field borderless ref="contraseña">
                <q-input
                  minlength="6"
                  maxlength="12"
                  hint="6 a 12 caracteres. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
                  dense
                  input-debounce="0"
                  :error="$v.UsuarioExternoModel.contraseña.$error"
                  :rules="[
                    (val) =>
                      !!val ||
                      'Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                    (val) =>
                      validatePassword(val) ||
                      'Contraseña no válida. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                  ]"
                  class="col-12"
                  ref="contraseña"
                  v-model="UsuarioExternoModel.contraseña"
                  :type="isPwd ? 'password' : 'text'"
                  label="Introduce tu nueva contraseña"
                  bottom-slots
                >
                  <template
v-slot:error
                    >Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1
                    número, 1 letra minúscula y 1 mayúscula.</template
                  >
                  <template v-slot:append>
                    <q-icon
                      :name="isPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isPwd = !isPwd"
                    />
                  </template>
                </q-input>
              </q-field>
            </div>
            <div class="flex-item_20"></div>
          </div>
          <br />
          <br />
          <br />
          <br />
        </q-card-actions>
        <q-card-actions align="left">
          <div class="flex-container">
            <div class="flex-item_5"></div>
            <div class="flex-item_70">
              <q-field borderless ref="repetir_contraseña">
                <q-input
                  minlength="6"
                  required
                  maxlength="12"
                  hint="6 a 12 caracteres. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
                  dense
                  input-debounce="0"
                  :error="$v.UsuarioExternoModel.repetir_contraseña.$error"
                  :rules="[
                    (val) =>
                      !!val ||
                      'Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                    (val) =>
                      val === this.UsuarioExternoModel.contraseña ||
                      'Las contraseñas deben coincidir',
                    (val) =>
                      validatePassword(val) ||
                      'Contraseña no válida. 6 a 12 caracteres, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
                  ]"
                  class="col-12"
                  ref="repetir_contraseña"
                  v-model="UsuarioExternoModel.repetir_contraseña"
                  :type="isPwd2 ? 'password' : 'text'"
                  label="Repite tu nueva contraseña"
                  bottom-slots
                >
                  <template
v-slot:error
                    >Dato Obligatorio. 6 a 12 caracteres, se requiere al menos 1
                    número, 1 letra minúscula y 1 mayúscula.</template
                  >
                  <template v-slot:append>
                    <q-icon
                      :name="isPwd2 ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isPwd2 = !isPwd2"
                    />
                  </template>
                </q-input>
              </q-field>
            </div>
            <div class="flex-item_20"></div>
          </div>
        </q-card-actions>
        <br />

        <q-card-actions align="right">
          <q-btn
            title="enviar contraseña actualizada"
            @click="validar"
            class="ma-2"
            text-color="black"
            color="lime"
            >enviar</q-btn
          >
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import '@/components/Usuarios/assets/css/css_usuario_vue.css';
import { required, email } from 'vuelidate/lib/validators';
import { Cookies } from 'quasar';
import router from '@/router';
import {
  QInput,
  QSelect,
  QCard,
  QList,
  QField,
  QItem,
  QItemSection,
  QItemLabel,
  QCardSection,
  QCardActions,
  QBtnToggle,
  QCheckbox,
  QTable,
  QTh,
  QTr,
  QTd,
  QToggle,
  ClosePopup,
  QDialog
} from 'quasar';
/* import Cargando from "@/components/shared/components/Cargando"; */

export default {
  methods: {
    validar () {
      this.$v.UsuarioExternoModel.$touch();
      if (this.$v.UsuarioExternoModel.$error) {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      } else if (this.comprobar_contraseñas()) {
        let request = {
          controller: '/Password',
          filter: {},
          data: {
            mail: this.$route.query.mail,
            token: this.$route.query.token.replace(/ /g, '+'),
            password: this.UsuarioExternoModel.contraseña
          }
        };
        this.$store
          .dispatch('TSZ/putPassword', request)
          .then((response) => {
            this.ok = true;

            this.$router.push({ name: 'login' });

            this.mostrar_mensajes('Contraseña reseteada correctamente', 'blue');
          })

          .catch((err) => {
            this.ok = false;
            this.mostrar_mensajes(err.response.data, 'red');
          });
      } else {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      }
    },

    comprobar_accion () {
      if (this.ok) {
        this.$router.push({ name: 'login' });
      }
    },

    myTrim (x) {
      return x.replace(/^\s+|\s+$/gm, '');
    },

    comprobar_contraseñas () {
      if (
        this.myTrim(this.UsuarioExternoModel.contraseña) === '' ||
        this.myTrim(this.UsuarioExternoModel.repetir_contraseña) === '' ||
        !this.validatePassword(
          this.myTrim(this.UsuarioExternoModel.contraseña)
        ) ||
        !this.validatePassword(
          this.myTrim(this.UsuarioExternoModel.repetir_contraseña)
        ) ||
        this.myTrim(this.UsuarioExternoModel.repetir_contraseña) !=
          this.myTrim(this.UsuarioExternoModel.contraseña)
      ) { return false; } else return true;
    },

    validatePassword (password_) {
      var re1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,12}$/;

      return re1.test(password_);

      // [‎26/‎02/‎2020 12:26] Roca Molina, Pedro:
      // MinimumLength(6).MaximumLength(12).Matches(@"^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,12}$").WithMessage("Password de 6 a 12 caracteres. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula").When(d => d.User.IsExternal == true);
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.$q.notify({
        message: mensaje,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [
          {
            icon: 'close',
            color: 'white',
            handler: () => this.comprobar_accion()
          }
        ]
      });
    }
  },

  validations: {
    UsuarioExternoModel: {
      contraseña: { required },
      repetir_contraseña: { required }
    }
  },

  data () {
    return {
      mensaje: '',
      // mostrar_mensaje: false,
      mensaje_cargando: 'registrando',
      ok: false,
      isPwd: true,
      isPwd2: true,
      Datos_user: {
        mail: '',
        isExternal: null,
        appName: null,
        password: null,
        id: 0
      },
      Datos_profile: {
        nombre: null,
        apellidos: null,
        empresa: null,
        telefono: null,
        id: 0
      },
      UsuarioExternoModel: {}
    };
  },

  components: {
    /*  Cargando, */
    QInput,
    QSelect,
    QCard,
    QList,
    QField,
    QCardSection,
    QCardActions,
    QBtnToggle,
    QCheckbox,
    QTable,
    QTh,
    QTr,
    QTd,
    QToggle,
    ClosePopup,
    QDialog
  }
};
</script>
